module.exports = __webpack_public_path__ + "media/images/front/img_user-6a7517b37bd887195df62512f787a304.jpg";